"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRemoveBasketItemErrorResponse = exports.RemoveBasketItemFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'remove-basket-item-failed';
const RemoveBasketItemFailedEvent = exports.RemoveBasketItemFailedEvent = Name;
const isRemoveBasketItemErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isRemoveBasketItemErrorResponse = isRemoveBasketItemErrorResponse;
//# sourceMappingURL=index.js.map